import {SmartSiteBaseApiV2} from "../SmartSiteBaseApiV2";

export class WorkplaceTypeApi extends SmartSiteBaseApiV2 {

    public get ControllerName(): any {
        return 'workplaceType';
    }
    
}